'use client';

import dynamic from 'next/dynamic';

export const AnchorPositioningAreas = dynamic(
  () => import('./AnchorPositioningAreas')
);

export const AbsoluteFixedContainingBlocks = dynamic(
  () => import('./AbsoluteFixedContainingBlocks')
);
